var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrendPump(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15,22.7H9c-5.4,0-7.8-2.3-7.8-7.7V9c0-5.4,2.3-7.8,7.8-7.8h6c5.4,0,7.8,2.3,7.8,7.8v6C22.8,20.4,20.4,22.7,15,22.7z M9,2.7 C4.4,2.7,2.8,4.4,2.8,9v6c0,4.6,1.6,6.2,6.3,6.2h6c4.6,0,6.3-1.6,6.3-6.2V9c0-4.6-1.6-6.3-6.3-6.3H9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7,7.7l-0.7-1.9c-0.1-0.4-0.6-0.6-1-0.5L15.2,6c-0.4,0.1-0.6,0.6-0.5,1c0.1,0.4,0.6,0.6,1,0.5l0.3-0.1l-3.8,6.6L9.4,13 c-0.3-0.1-0.6,0-0.8,0.3l-3,3.9c-0.3,0.3-0.2,0.8,0.1,1.1c0.1,0.1,0.3,0.2,0.5,0.2c0.2,0,0.5-0.1,0.6-0.3l2.7-3.5l3,0.9 c0.3,0.1,0.7,0,0.9-0.3l4-7l0,0c0.1,0.4,0.6,0.6,1,0.5S18.9,8.1,18.7,7.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrendPump);
export default __webpack_public_path__ + "static/media/trend-pump.522ea099dcb947302a7c5799e22a5dc1.svg";
export { ForwardRef as ReactComponent };